export default function Component$find ( selector ) {
	return this.instance.fragment.find( selector );
}
